'use strict';

import {contractModel} from "../../models/contractmodel.js";
import {checklistsModel} from "../../models/checklistsmodel.js";

export class ContractsChecklistsCtrl
{
	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	item = {};
	checklists = [];
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.item = new contractModel(jsDataService.get('applicationBase', {}), $filter, jsDataService);
		this.loadData();
	}
	
	loadData(){
		if(this.jsDataService.get('cfgDataUrl')){
			this.promise = this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgDataUrl'),
				method: 'GET',
				params: {}
			}).then((response) => {
				if(response.data.success){
					this.setData(response.data.data);
				}
			}, () => {});
		}
	}
	
	setData(data){
		this.checklists = [];
		for(let row of data){
			this.checklists.push(new checklistsModel(row, this.$filter, this.jsDataService));
		}
	}
	
	preview(ev, evaluation){
		if(typeof(evaluation.preview_url) !== 'undefined'){
			this.$scope.$root.goUrl(evaluation.preview_url);
		}
	}
	
	edit(ev, evaluation){
		if(typeof(evaluation.edit_url) !== 'undefined'){
			this.$scope.$root.goUrl(evaluation.edit_url);
		}
	}
	
	confirmation(ev, evaluation){
		if(typeof(evaluation.confirmation_url) !== 'undefined'){
			this.$scope.$root.goUrl(evaluation.confirmation_url);
		}
	}
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
	
	
}